
studioSelector.on('click', function () {

    if(window.innerWidth > 991) {

        var index = studioSelector.index($(this));

        studioCarousel.slick('slickPause');

        studioCarousel.slick('slickGoTo', index);

    }else {

        if(!($(this).hasClass('active'))){

            var currentActive = $(this).siblings('.active'),
                currentActiveContent = currentActive.find('.select-content'),
                currentActiveWrapper = currentActive.find('.content-wrap');

            var current = $(this),
                currentContent = current.find('.select-content'),
                currentWrapper = current.find('.content-wrap');

            currentActive.removeClass('show-bg');

            currentActiveContent.css('height', currentActiveWrapper.outerHeight());

            currentActive.removeClass('active');

            currentActiveContent.css('height', 0).one(transitionEvent, function () {
               currentActiveContent.removeAttr('style');

               $("html, body").stop().animate({scrollTop: current.offset().top - 200}, 600);

               setTimeout(function () {
                   currentContent.css('height', 0);

                   current.addClass('active');

                   currentContent.css('height', currentWrapper.outerHeight()).one(transitionEvent, function () {
                       currentContent.removeAttr('style');

                       current.addClass('show-bg');
                   })
               }, 600);
            });

        }

    }

});

serviceSelector.on('click', function () {

    if(window.innerWidth > 991) {

        var index = serviceSelector.index($(this));

        serviceCarousel.slick('slickPause');

        serviceCarousel.slick('slickGoTo', index);

    }else {

        if(!($(this).hasClass('active'))){

            var currentActive = $(this).siblings('.active'),
                currentActiveContent = currentActive.find('.select-content'),
                currentActiveWrapper = currentActive.find('.content-wrap');

            var current = $(this),
                currentContent = current.find('.select-content'),
                currentWrapper = current.find('.content-wrap');

            // console.log(currentActive);

            currentActive.removeClass('show-bg');

            currentActiveContent.css('height', currentActiveWrapper.outerHeight());

            currentActive.removeClass('active');

            currentActiveContent.css('height', 0).one(transitionEvent, function () {
                currentActiveContent.removeAttr('style');

                $("html, body").stop().animate({scrollTop: current.offset().top - 200}, 600);

                setTimeout(function () {
                    currentContent.css('height', 0);

                    current.addClass('active');

                    currentContent.css('height', currentWrapper.outerHeight()).one(transitionEvent, function () {
                        currentContent.removeAttr('style');

                        current.addClass('show-bg');
                    })
                }, 600);
            });

        }

    }

});

$('.hamburger').on('click', function () {

    var body = $('body');

   body.toggleClass('fixed menu-active');

   if( body.hasClass( 'user-menu-active' ) ) {

       body.removeClass( 'user-menu-active' );

   }

});

$('.topbar .user-trigger[data-show-user-menu]').on('click', function (e) {

    e.preventDefault();

    var body = $('body');

    body.toggleClass('fixed user-menu-active');

    if( body.hasClass( 'menu-active' ) ) {

        body.removeClass( 'menu-active' );

    }

});

$('.training .training-selector .list-item').on( 'click', function() {
    var filterValue = $( this ).attr('data-filter');

    $(this).addClass('active').siblings().removeClass('active');

    trainingGrid.isotope({ filter: filterValue });

    trainingSelect.find('select').val(filterValue);
    trainingSelect.find('select').trigger('change');
});

$('.coaches .training-selector .list-item').on( 'click', function() {
    var filterValue = $( this ).attr('data-filter');

    $(this).addClass('active').siblings().removeClass('active');

    coachesGrid.isotope({ filter: filterValue });

    coachesSelect.find('select').val(filterValue);
    coachesSelect.find('select').trigger('change');
});

trainingSelect.find('select').on('change', function () {

    trainingGrid.isotope({ filter: $(this).val() });

    trainingSelect.siblings('.training-selector').find('[data-filter="'+ $(this).val() +'"]').addClass('active').siblings().removeClass('active');
});

coachesSelect.find('select').on('change', function () {

    coachesGrid.isotope({ filter: $(this).val() });

    coachesSelect.siblings('.training-selector').find('[data-filter="'+ $(this).val() +'"]').addClass('active').siblings().removeClass('active');
});

var pricePackage = $('.prices .dropdown-box .package');

pricePackage.on('click', function (e) {

   if(!($(e.target).attr('href'))){

       var block = $(this),
           table = $(this).find(".table"),
           tableInner = table.find('.table-inner'),
           btnWrap = $(this).find('.button-wrap'),
           btn = btnWrap.find('.button'),
           packagePrice = $(this).find('.package-price'),
           tableHeight, btnHeight;

       if(block.hasClass('active')){
           block.addClass('opening');

           tableHeight = tableInner.outerHeight();

           packagePrice.removeClass('move');

           table.css('height', tableHeight).css('height', 0).one(transitionEvent, function (e) {
               table.removeAttr('style');
           });

           btnHeight = btn.outerHeight(true);

           btnWrap.css('height', btnHeight).css('height', 0).one(transitionEvent, function (e) {
               btnWrap.removeAttr('style');
               block.removeClass('opening active');
           })

       }else {
           block.addClass('opening active');

           packagePrice.addClass('move');

           tableHeight = tableInner.outerHeight();

           table.css('height', 0).css('height', tableHeight).one(transitionEvent, function (e) {
               table.removeAttr('style');
           });

           btnHeight = btn.outerHeight(true);

           btnWrap.css('height', 0).css('height', btnHeight).one(transitionEvent, function (e) {
               btnWrap.removeAttr('style');
               block.removeClass('opening');
           })
       }
   }
});

//SCHEDULE CARD REVEAL

var scheduleCarousel = $('.schedules .weeks-carousel');

scheduleCarousel.on('click', '.cards .card:not(.filter-mask)', function (e) {

    if(!($(this).hasClass('active')) && !($(e.target).hasClass('close'))){

        scheduleCarousel.find('.cards .card').removeClass('active');

        $(this).addClass('active');

    }else if($(this).hasClass('active') && $(e.target).hasClass('close')) {

        $(this).removeClass('active');

    }

});

//SCHEDULE MOBILE DROPDOWN REVEAL

scheduleCarousel.on('click', '.block .day', function (e) {

    if(window.innerWidth < 991) {

        //console.log('click');

        var day = $(this),
            cardsWrap = day.siblings('.cards-wrap'),
            cards = cardsWrap.find('.cards'),
            col = day.closest('.col');

        //console.log(col);

        day.addClass('revealing');

        if(col.hasClass('active')){

            //console.log('Hiding');

            col.addClass('moving');

            cardsWrap.find('.card.active').removeClass('active');

            cardsWrap.css('height', cards.outerHeight()).css('height', 0).one(transitionEvent, function () {
                cardsWrap.removeAttr('style');

                col.removeClass('active moving');
                day.removeClass('revealing');
            })

        }else {

            //console.log('Revealing');

            cardsWrap.css('height', 0).css('height', cards.outerHeight()).one(transitionEvent, function () {
                cardsWrap.removeAttr('style');

                col.addClass('active');
                day.removeClass('revealing');
            })

        }
    }

});

//MODAL FUNCTIONS

var bannerClose = $('.banner-wrap, .banner-wrap .close');

bannerClose.on('click', function (e) {
    if (e.target === this) {
        if (!$('.banner-wrap-main').length > 0) {
            $('.banner-wrap').removeClass('active');
            $('body').removeClass('banner-active');
        }
    }
});

$(document).keyup(function(e) {
    if (e.keyCode === 27) {
        if (!$('.banner-wrap-main').length > 0) {
            $('.club-changer').removeClass('active');
            $('.banner-wrap').removeClass('active');
            $('body').removeClass('banner-active');
        }
    }
});

//GDPR HANDLING

var cookieBox = $('.cookie-box'),
    agreeBtn = cookieBox.find('a[data-type=agree]');

agreeBtn.on('click', function () {

    setCookie('reformatas_cookie_agree', 1, 365);

    cookieBox.addClass('hide');

});

$('.sticky-right-notice .notice-close').on('click', function () {
    $(this).parent().toggleClass('closed');
    setCookie('notice_closed', 1, 365);
});

//HANDLE SCHEDULE SELECTIONS

var schedulesSelectors = $('.schedules .selector');

schedulesSelectors.find('select').on('change', function (e) {

    var select = $(this),
        val = select.val();

    if(val === 'all'){

        select.closest('.selector').removeClass('selected');

    }else {

        select.closest('.selector').addClass('selected');

    }

    var cardAttr = '';
    var colAttr = '';

    var couch = schedulesSelectors.find('select[name="coaches"]').val(),
        workout = schedulesSelectors.find('select[name="workouts"]').val(),
        time = schedulesSelectors.find('select[name="time"]').val(),
        reserved = schedulesSelectors.find('select[name="reserved"]').val();

    if(typeof couch !== 'undefined' && couch !== 'all'){
        cardAttr += '[data-couch="'+ couch +'"]';
    }

    if(typeof workout !== 'undefined' && workout !== 'all') {
        cardAttr += '[data-workout="'+ workout +'"]';
    }

    if(typeof time !== 'undefined' && time !== 'all') {
        cardAttr += '[data-date="'+ time +'"]';
    }

    if(typeof reserved !== 'undefined' && reserved !== 'all') {
        cardAttr += '[data-reserved="true"]';
    }

    var scheduleTable = $('.schedules .weeks-carousel');

    scheduleTable.find('.cards .card.active').removeClass('active');

    //console.log(cardAttr);

    scheduleTable.find('.day, .card').addClass('filter-mask');

    scheduleTable.find('.card'+ cardAttr).removeClass('filter-mask').closest('.col').find('.day').removeClass('filter-mask');

});

schedulesSelectors.find('.clear').on('click', function () {

    $(this).siblings('select').val('all').trigger('change');

});

//HANDLE SCHEDULE SELECTIONS

var invoicesSelectors = $('.my-invoices .selector');

invoicesSelectors.find('select').on('change', function (e) {

    var select = $(this),
        val = select.val();

    var rowsToShow, rowsToHide;

    if(val === 'all'){

        select.closest('.selector').removeClass('selected');

        rowsToShow = $('.my-invoices .invoices .row.hide');
        rowsToHide = false;

    }else {

        select.closest('.selector').addClass('selected');

        rowsToShow = $('.my-invoices .invoices .row[data-status="'+ val +'"]');
        rowsToHide = $('.my-invoices .invoices .row[data-status!="'+ val +'"]');

    }

    if(rowsToHide){
        rowsToHide.css('height', rowsToHide.children().outerHeight()).css('height', 0).one(transitionEvent, function (e) {

            $(e.target).addClass('hide').removeAttr('style');

        });
    }

    rowsToShow.css('height', 0).css('height', rowsToShow.children().outerHeight()).one(transitionEvent, function (e) {

        $(e.target).removeClass('hide').removeAttr('style');

    })

});

invoicesSelectors.find('.clear').on('click', function () {

    $(this).siblings('select').val('all').trigger('change');

});

//HANDLE LOGIN BOX

var openServiceLoginBox = function () {

    $('body').addClass('fixed');

    var serviceLogin = $('.self-service-login'),
        boxOuter = serviceLogin.find('.login-box-outer');

    serviceLogin.addClass('reveal').one(transitionEvent, function (e) {
       boxOuter.addClass('reveal');
       serviceLogin.find('.window.login input[name="email"]')[0].focus();
    })

};

var closeServiceLoginBox = function () {

    var serviceLogin = $('.self-service-login'),
        boxOuter = serviceLogin.find('.login-box-outer');

    boxOuter.removeClass('reveal').one(transitionEvent, function (e) {
        serviceLogin.removeClass('reveal');

        if (!$('body').hasClass('menu-active')) {
            $('body').removeClass('fixed');
        }

        serviceLogin.find('.window.login').removeClass('hide').siblings().addClass('hide');
    });

    serviceLogin.find('input').val('');
    serviceLogin.find('.input.error').removeClass('error');
    serviceLogin.find('.error-explain').remove();

};

$('body').on('click', 'a[data-service-login]', function (e) {

    e.preventDefault();

    openServiceLoginBox();

});

$('.self-service-login .login-box-close, .self-service-login a[data-service-close-box]').on('click', function () {

    closeServiceLoginBox();

});

$('.self-service-login').on('click', function (e) {

    var serviceLogin = $('.self-service-login'),
        boxOuter = serviceLogin.find('.login-box-outer');

    if(serviceLogin.hasClass('reveal') && boxOuter.hasClass('reveal')){
        if($(e.target).closest('.login-box').length === 0) {
            closeServiceLoginBox();
        }
    }
});

$('.self-service-login a[data-lost-psw]').on('click', function () {

    var loginBox = $(this).closest('.login-box-inner'),
        window = $(this).closest('.window'),
        windowInner = window.find('.window-inner'),
        windowSibling = window.next(),
        windowSiblingInner = windowSibling.find('.window-inner');

    window.addClass('pre-hide').css('height', windowInner.outerHeight()).css('height', windowSiblingInner.outerHeight()).one(transitionEvent, function () {

        loginBox.css('height', windowSiblingInner.outerHeight());
        window.removeAttr('style').addClass('hide').removeClass('pre-hide');
        windowSibling.css('height', 0).css('height', windowSiblingInner.outerHeight()).one(transitionEvent, function () {

            loginBox.removeAttr('style');
            windowSibling.removeClass('hide').removeAttr('style');

        })
    });
});

//HANDLE LOGOUT

$('a[data-user-logout]').on('click', function () {

    $(this).addClass('loading');

    document.cookie = "re_service_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

    location.reload();

});

//HANDLE CONTACTS PINS

var contactsCards = $('.contacts .cards .card[data-slug]'),
    contactsPins = $('.contacts .custom-map .pin[data-slug]');

var adjustCustomMapBySlug = function(slug) {

    contactsCards.removeClass('active');
    contactsPins.removeClass('active');

    contactsCards.filter('[data-slug="'+ slug +'"]').addClass('active');
    contactsPins.filter('[data-slug="'+ slug +'"]').addClass('active');

};

contactsCards.on('click', function () {

    var card = $(this),
        cardSlug = card.attr('data-slug');

    adjustCustomMapBySlug(cardSlug);

});

contactsPins.find('svg').on('click', function () {

    var pin = $(this).closest('.pin'),
        pinSlug = pin.attr('data-slug');

    adjustCustomMapBySlug(pinSlug);

});

//HANDLE CLUB COOKIE SWITCH

$('*[data-switch-club-cookie]').on('click', function (e) {

    e.preventDefault();

    var newSlug = $(this).attr('data-switch-club-cookie');

    setCookie('active-club', newSlug, 30);

    location.reload();

});


var vacation_activation_date = $('input[name="vacation_activation_date"]');
var vacation_end_date = $('input[name="vacation_end_date"]');

$('.order-vacation').on('click', function () {
    $(this).hide();
    $('.vacation-form').show();
});
$('.cancel-contract-vacation').on('click', function () {

    $(this).addClass('loading');

    pd = new FormData();
    pd.append('action', 'contract_vacation_cancel');
    pd.append('conid', $(this).data('conid'));
    pd.append('pauseid', $(this).data('pauseid'));
    pd.append('from', $(this).data('pausefrom'));
    pd.append('till', $(this).data('pausetill'));

    $.ajax({
        type: 'POST',
        url: postre['ajax_url'],
        data: pd,
        dataType: 'json',
        contentType: false,
        processData: false,
        success: function (response) {

            if(response.success){

                window.location.reload();

            }

        }
    });
});
$('.edit-contract-vacation').on('click', function () {

    $(this).addClass('loading');

    pd = new FormData();
    pd.append('action', 'contract_vacation_edit');
    pd.append('conid', $(this).data('conid'));
    pd.append('pauseid', $(this).data('pauseid'));
    pd.append('from', $(this).data('pausefrom'));
    pd.append('till', $(this).data('pausetill'));

    $.ajax({
        type: 'POST',
        url: postre['ajax_url'],
        data: pd,
        dataType: 'json',
        contentType: false,
        processData: false,
        success: function (response) {

            if(response.success){

                window.location.reload();

            }

        }
    });
});

$('.cancel-subscription-vacation').on('click', function () {

    $(this).addClass('loading');

    pd = new FormData();
    pd.append('action', 'subscription_vacation_cancel');
    pd.append('subid', $(this).data('subid'));
    pd.append('pauseid', $(this).data('pauseid'));

    $.ajax({
        type: 'POST',
        url: postre['ajax_url'],
        data: pd,
        dataType: 'json',
        contentType: false,
        processData: false,
        success: function (response) {

            if(response.success){

                window.location.reload();

            }

        }
    });
});
$('.order-vacation-cancel').on('click', function () {
    $('.vacation-form').hide();
    $('.order-vacation').show();

    $('input[name="vacation_activation_date"]').val('');
    $('input[name="vacation_end_date"]').val('').addClass('disabled');
    vacation_end_date.datepicker('reset');
    vacation_activation_date.datepicker('reset');
});

$('.order-vacation-activate').on('click', function () {

    if (vacation_activation_date.val() && vacation_end_date.val()) {
        $(this).addClass('loading')



        pd = new FormData();

        if ($(this).data('contract')) {
            pd.append('action', 'contract_vacation_activate');
            pd.append('conid', $(this).data('contract'));
        } else {
            pd.append('action', 'subscription_vacation_activate');
            pd.append('subid', $(this).data('subscription'));
        }

        var newfrom = new Date($('input[name="vacation_activation_date"]').val());
        newfrom.setDate(newfrom.getDate() - 0);
        newfrom = dateToYMD(newfrom);
        pd.append('from', newfrom);

        var newtill = new Date($('input[name="vacation_end_date"]').val());
        newtill.setDate(newtill.getDate() + 1);
        newtill = dateToYMD(newtill);
        pd.append('till', newtill);

        $.ajax({
            type: 'POST',
            url: postre['ajax_url'],
            data: pd,
            dataType: 'json',
            contentType: false,
            processData: false,
            success: function (response) {

                if(response.success){

                    window.location.reload();

                }

            }
        });
    } else {
        if (!vacation_activation_date.val()) {
            vacation_activation_date.parent().parent().addClass('error');
        }
        if (!vacation_end_date.val()) {
            vacation_end_date.parent().parent().addClass('error');
        }
    }

});

var datepickerTemplate = '';

datepickerTemplate += '<div class="datepicker-container datepicker-one-time-service">';
datepickerTemplate += '<div class="datepicker-panel" data-view="days picker">';
datepickerTemplate += '<ul data-view="months-selector">';
datepickerTemplate += '<li data-view="month prev"></li>';
datepickerTemplate += '<li data-view="month current"></li>';
datepickerTemplate += '<li data-view="month next"></li>';
datepickerTemplate += '</ul>';
datepickerTemplate += '<ul data-view="week"></ul>';
datepickerTemplate += '<ul data-view="days"></ul>';
datepickerTemplate += '</div>';
datepickerTemplate += '</div>';

function dateToYMD(date) {
    var d = date.getDate();
    var m = date.getMonth() + 1; //Month from 0 to 11
    var y = date.getFullYear();
    return '' + y + '-' + (m<=9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d);
}

if(vacation_activation_date.length > 0) {

    vacation_activation_date.datepicker({
        startDate: datepicker.start,
        endDate: datepicker.hardlast,
        language: 'lt-LT',
        autoHide: true,
        trigger: 'input[name="vacation_activation_date"]',
        template: datepickerTemplate,
        zIndex: 1200,
        offset: -300,
        filter: function(date, view) {

        }
    }).on('change', function (e) {

        var val = $.trim($(this).val());
        $('input[name="vacation_end_date"]').val('').removeClass('disabled');
        vacation_end_date.datepicker('reset');
        vacation_end_date.datepicker('setStartDate', val);

        if (datepicker.end != datepicker.hardlast) {
            var newend = new Date(val);
            newend.setDate(newend.getDate() + (parseInt(datepicker.days) - 1));
            newend = dateToYMD(newend);

            if (newend > datepicker.hardlast) {
                vacation_end_date.datepicker('setEndDate', datepicker.hardlast)
            } else {
                vacation_end_date.datepicker('setEndDate', newend)
            }
        }

    }).on('click', function () {

        // $(this).datepicker('show');

    });

    vacation_end_date.datepicker({
        startDate: datepicker.start,
        endDate: datepicker.end,
        language: 'lt-LT',
        autoHide: true,
        trigger: 'input[name="vacation_end_date"]',
        template: datepickerTemplate,
        zIndex: 1200,
        offset: -300,
        filter: function(date, view) {

        }
    }).on('change', function (e) {



    }).on('click', function () {

        // $(this).datepicker('show');

    });

}